export const apiKeyValidator = (key: string): boolean => {
  return !!key.trim();
};
